import React from "react";

export function StockBarchartFinanceToggle({ panelOpen, onToggle, connected, userId }) {
  if (!userId) return null;

  return (
    <button
      type="button"
      className={`btn btn-sm btn-primary-outline${panelOpen ? " active" : ""}`}
      onClick={onToggle}
      aria-expanded={panelOpen}
      aria-controls="stock-barchart-panel-body"
      title={
        connected
          ? "Barchart connected — expand to manage"
          : "Connect Barchart to refresh holdings from your watchlist"
      }
      style={{ marginBottom: 2, flexShrink: 0 }}
    >
      Barchart {panelOpen ? "▾" : "▸"}
    </button>
  );
}

export function StockBarchartFinancePanelBody({
  connected,
  updatedAt,
  loading,
  loginSessionId,
  showManualImport,
  setShowManualImport,
  manualCookiesJson,
  setManualCookiesJson,
  authNotice,
  setAuthNotice,
  handleConnect,
  handleCompleteLogin,
  handleCancelLogin,
  handleDisconnect,
  handleSaveManualCookies,
  userId,
}) {
  if (!userId) {
    return (
      <div className="panel" style={{ marginBottom: 12 }}>
        <p className="panel-hint" style={{ margin: 0 }}>
          Sign in to connect your Barchart account for holdings refresh.
        </p>
      </div>
    );
  }

  return (
    <section
      className="card"
      style={{ marginBottom: 16, padding: "12px 16px" }}
      aria-labelledby="stock-barchart-heading"
    >
      <h3 id="stock-barchart-heading" style={{ margin: "0 0 8px", fontSize: 15 }}>
        Barchart
      </h3>
      <p style={{ margin: "0 0 12px", fontSize: 14, color: "#57606a" }}>
        Holdings refresh pulls your Barchart watchlist (same columns as CSV export). Each user connects their
        own Barchart session; credentials are not shared.
      </p>

      {authNotice ? (
        <div
          role="alert"
          style={{
            marginBottom: 12,
            padding: "10px 12px",
            background: "#fff8e5",
            border: "1px solid #d4a72c",
            borderRadius: 6,
            fontSize: 14,
            color: "#24292f",
            display: "flex",
            alignItems: "flex-start",
            justifyContent: "space-between",
            gap: 12,
          }}
        >
          <span>{authNotice}</span>
          <button type="button" className="btn btn-sm btn-secondary" onClick={() => setAuthNotice("")}>
            Dismiss
          </button>
        </div>
      ) : null}

      <div id="stock-barchart-panel-body">
        {connected ? (
          <div style={{ display: "flex", alignItems: "center", gap: 12, flexWrap: "wrap" }}>
            <span style={{ color: "#1a7f37", fontWeight: 500 }}>Your Barchart session is connected</span>
            {updatedAt ? (
              <span style={{ fontSize: 13, color: "#6e7681" }}>
                Updated {new Date(updatedAt).toLocaleString()}
              </span>
            ) : null}
            <button
              type="button"
              className="btn btn-sm btn-outline-secondary"
              onClick={handleDisconnect}
              disabled={loading}
            >
              {loading ? "Disconnecting…" : "Disconnect"}
            </button>
            <button
              type="button"
              className="btn btn-sm btn-outline-primary"
              onClick={handleConnect}
              disabled={loading}
            >
              Reconnect
            </button>
          </div>
        ) : (
          <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
            <div style={{ display: "flex", alignItems: "center", gap: 12, flexWrap: "wrap" }}>
              <button
                type="button"
                className="btn btn-sm btn-primary"
                onClick={handleConnect}
                disabled={loading}
              >
                {loading ? "Starting…" : "Connect your Barchart account"}
              </button>
              <span style={{ fontSize: 13, color: "#6e7681" }}>
                Opens Barchart login in a server browser window.
              </span>
            </div>

            {loginSessionId ? (
              <div style={{ display: "flex", alignItems: "center", gap: 12, flexWrap: "wrap" }}>
                <button
                  type="button"
                  className="btn btn-sm btn-primary"
                  onClick={handleCompleteLogin}
                  disabled={loading}
                >
                  {loading ? "Saving…" : "Save session"}
                </button>
                <button
                  type="button"
                  className="btn btn-sm btn-secondary"
                  onClick={handleCancelLogin}
                  disabled={loading}
                >
                  Cancel
                </button>
              </div>
            ) : null}

            <button
              type="button"
              className="btn btn-sm btn-link"
              style={{ alignSelf: "flex-start", padding: 0 }}
              onClick={() => setShowManualImport((v) => !v)}
            >
              {showManualImport ? "Hide manual cookie import" : "Import cookies manually instead"}
            </button>

            {showManualImport ? (
              <div>
                <p style={{ margin: "0 0 8px", fontSize: 13, color: "#57606a" }}>
                  Log in to barchart.com in your browser, export cookies for .barchart.com as JSON, and paste
                  below.
                </p>
                <textarea
                  className="form-control"
                  rows={5}
                  value={manualCookiesJson}
                  onChange={(e) => setManualCookiesJson(e.target.value)}
                  placeholder='[{"name":"...","value":"...","domain":".barchart.com","path":"/"}]'
                  style={{ width: "100%", fontFamily: "monospace", fontSize: 12, marginBottom: 8 }}
                />
                <button
                  type="button"
                  className="btn btn-sm btn-primary"
                  onClick={handleSaveManualCookies}
                  disabled={loading}
                >
                  {loading ? "Saving…" : "Save cookies"}
                </button>
              </div>
            ) : null}
          </div>
        )}
      </div>
    </section>
  );
}
